import React, { useEffect } from "react";
import { useUsuario } from "../../../Hooks/UsuarioHook";
import { useUsuarioPrefeitura } from "../../../Hooks/UsuarioPrefeituraHook";

export const LoginUsuarioPrefeitura = () => {
  const { checarToken, usuarioPrefeitura, token } = useUsuarioPrefeitura();


 

  const verificarToken = async () => {
    try {
      //showLoader("Checando Autenticação!");
      await checarToken();
    } catch (error) {
      console.error("Erro ao checar token:", error);
      
    } finally {
      //hideLoader();
    }
  };

  useEffect(() => {
    verificarToken();
  }, [token]);
  useEffect(()=>{
    window.alert(usuarioPrefeitura?.usuario?.id)
    if(usuarioPrefeitura?.usuario?.id){
        //window.location.href = `http://localhost:3000/iss/${usuarioPrefeitura.entidade.banco}`
    }
  },[usuarioPrefeitura])

  

  return (
    <div style={{ height: "100vh", overflow: "hidden", margin: 0, padding: 0 }}>
      {/* <h1>{`https://solucoes.sinsoft.com.br/login-unico/?${banco&&banco.length>0?`entidade=${banco}&`:""}url=${window.location.href}`}</h1> */}
      <iframe
        src={`https://solucoes.sinsoft.com.br/login-unico/?url=${window.location.href}`}
        style={{ width: "100%", height: "100%", border: "none" }}
        title="Login"
      />
    </div>
  );
};
